import { render } from "./UiTheHeader.vue?vue&type=template&id=9d6dddac&scoped=true"
import script from "./UiTheHeader.vue?vue&type=script&lang=js"
export * from "./UiTheHeader.vue?vue&type=script&lang=js"

import "./UiTheHeader.vue?vue&type=style&index=0&id=9d6dddac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9d6dddac"

export default script